// onload directive
//
//   <img src="..." ng-onload="vm.onImageLoad($event)" />

let module = angular.module('app.directives');

module.directive('ngOnload', [
  '$parse',
  function ($parse) {
    'ngInject';
    return {
      restrict: 'A',
      link: function (scope, elem, attrs) {
        var fn = $parse(attrs.ngOnload);
        elem.on('load', function (event) {
          scope.$apply(function () {
            fn(scope, { $event: event });
          });
        });
      },
    };
  },
]);



// WEBPACK FOOTER //
// ./app/directives/ng-onload.js